import React from "react";
import * as PropTypes from "prop-types";
import FormatMessage from "../../messages/FormatMessage";
import dot from "dot-object";
import LearnMore_LightBox from "./LearnMore_LightBox";

class RadioOptionWithValue extends React.Component {

    static propTypes = {
        beanName: PropTypes.string,
        property: PropTypes.string,
        key: PropTypes.string,
        noOfKeys: PropTypes.string,
        questionKey: PropTypes.string,
        onClick: PropTypes.func,
        required: PropTypes.string,
        errorKey: PropTypes.string,
        state: PropTypes.string,
        requireOptional: PropTypes.string,
        requireExplain: PropTypes.string,
        optionalField: PropTypes.string,
        instructionText: PropTypes.string,
        instructionExplain: PropTypes.string,
        linkToPageID: PropTypes.string,
        hintLabel: PropTypes.string,
        questionAdditionalInstructions: PropTypes.string,
        repeaterShowHide: PropTypes.string,
        controlInsideRepeater: PropTypes.string,
        radioNote: PropTypes.string,
        requireLightBox: PropTypes.string,
        dataType: PropTypes.string,
        dataTypeErrorKey: PropTypes.string,
        imagePath: PropTypes.string,
        option_label_1: PropTypes.string,
        option_label_2: PropTypes.string,
        option_label_3: PropTypes.string,
        option_label_4: PropTypes.string,
        option_label_5: PropTypes.string,
        option_label_6: PropTypes.string,
        option_label_7: PropTypes.string,
        option_label_8: PropTypes.string,
        option_label_9: PropTypes.string,
        option_label_10: PropTypes.string,
        option_label_11: PropTypes.string,
        option_label_12: PropTypes.string,
        option_label_13: PropTypes.string,
        option_label_14: PropTypes.string,
        option_label_15: PropTypes.string,
        option_label_16: PropTypes.string,
        option_label_17: PropTypes.string,
        option_label_18: PropTypes.string,
        option_label_19: PropTypes.string,
        option_label_20: PropTypes.string,
        option_value_1: PropTypes.string,
        option_value_2: PropTypes.string,
        option_value_3: PropTypes.string,
        option_value_4: PropTypes.string,
        option_value_5: PropTypes.string,
        option_value_6: PropTypes.string,
        option_value_7: PropTypes.string,
        option_value_8: PropTypes.string,
        option_value_9: PropTypes.string,
        option_value_10: PropTypes.string,
        option_value_11: PropTypes.string,
        option_value_12: PropTypes.string,
        option_value_13: PropTypes.string,
        option_value_14: PropTypes.string,
        option_value_15: PropTypes.string,
        option_value_16: PropTypes.string,
        option_value_17: PropTypes.string,
        option_value_18: PropTypes.string,
        option_value_19: PropTypes.string,
        option_value_20: PropTypes.string,
        option_labels: PropTypes.string,
        option_values: PropTypes.string
    }

    static defaultProps = {
        beanName: '',
        property: '',
        key: '',
        noOfKeys: '',
        questionKey: '',
        onClick: () => {
        },
        required: '',
        errorKey: '',
        state: '',
        requireOptional: '',
        requireExplain: '',
        optionalField: '',
        instructionText: '',
        instructionExplain: '',
        linkToPageID: '',
        hintLabel: '',
        questionAdditionalInstructions: '',
        repeaterShowHide: '',
        controlInsideRepeater: '',
        radioNote: '',
        requireLightBox: '',
        dataType: '',
        dataTypeErrorKey: '',
        imagePath: '',
        option_label_1: '',
        option_label_2: '',
        option_label_3: '',
        option_label_4: '',
        option_label_5: '',
        option_label_6: '',
        option_label_7: '',
        option_label_8: '',
        option_label_9: '',
        option_label_10: '',
        option_label_11: '',
        option_label_12: '',
        option_label_13: '',
        option_label_14: '',
        option_label_15: '',
        option_label_16: '',
        option_label_17: '',
        option_label_18: '',
        option_label_19: '',
        option_label_20: '',
        option_value_1: '',
        option_value_2: '',
        option_value_3: '',
        option_value_4: '',
        option_value_5: '',
        option_value_6: '',
        option_value_7: '',
        option_value_8: '',
        option_value_9: '',
        option_value_10: '',
        option_value_11: '',
        option_value_12: '',
        option_value_13: '',
        option_value_14: '',
        option_value_15: '',
        option_value_16: '',
        option_value_17: '',
        option_value_18: '',
        option_value_19: '',
        option_value_20: '',
        option_labels: '',
        option_values: ''
    }

    constructor(props) {
        super(props);
        this.state = {
            radioVal: "",
            showModal: false,
            application: {}
        }
        this.handleRadioChange = this.handleRadioChange.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.application != prevState.application) {
            return {
                application: nextProps.application,
                radioVal: dot.pick(nextProps.property, nextProps.application.applicationData)
            }
        }
        return null;
    }

    render() {
        const {
            beanName,
            property,
            questionKey,
            onClick,
            required,
            errorKey,
            requireOptional,
            pageid,
            requireExplain,
            requireLightBox,
            repeaterShowHide
        } = this.props;
        let radioOptionMap = new Map()
        let rbValues = []
        for (let i = 1; i <= 20; i++) {
            if (this.props["option_label_" + i] != undefined && this.props["option_label_" + i] != null &&
                this.props["option_label_" + i] != "" && this.props["option_value_" + i] != undefined &&
                this.props["option_value_" + i] != null && this.props["option_value_" + i] != "") {
                radioOptionMap.set(this.props["option_label_" + i], this.props["option_value_" + i])
            }
        }
        if (this.props.option_labels != undefined && this.props.option_labels != null && this.props.option_labels != "" &&
            this.props.option_values != undefined && this.props.option_values != null && this.props.option_values != "") {
            this.props.option_values.split(",").forEach((option_value) => {
                rbValues.push(option_value.trim())
            })
            this.props.option_labels.split(",").forEach((option_label, index) => {
                radioOptionMap.set(option_label.trim(), rbValues[index])
            })
        }

        var dynamicId = beanName + "-" + property.replaceAll(".", "-");
        return (
            <div>
                <div className={repeaterShowHide == "" ? "QuestionSection" : ""}>
                    <div className="Question">
                        {questionKey != "" &&
                            <div className="Question-title">
                                <span className="Question-titleText">
                                    <FormatMessage id={questionKey}/>
                                    {requireOptional != "" &&
                                        <span className="requireOptional">
                                            <FormatMessage id="control.requireOptional"/>
                                        </span>
                                    }
                                    {requireLightBox == "header" &&
                                        <a className="LearnMoreLink"
                                           onClick={() => this.handleShowModal()}>
                                            <FormatMessage id="control.explain"/>
                                        </a>
                                    }
                                </span>
                            </div>
                        }
                    </div>

                    <div className="AnswerField set">
                        <div className="RadioList element">
                            {Array.from(radioOptionMap.keys()).map((rbKey, i) => (
                                <div className="RadioListItem" key={rbKey}>
                                    <div className="RadioInput">
                                        <div>
                                            <input type="radio" property={property}
                                                   name={dynamicId}
                                                   id={dynamicId + "-" + i}
                                                   className={"RadioInput-input " + beanName + "-" + property + "-" + (i + 1)}
                                                   onClick={onClick}
                                                   value={radioOptionMap.get(rbKey)}
                                                   checked={this.state.radioVal == radioOptionMap.get(rbKey)}
                                                   onChange={(e) => this.handleRadioChange(property, radioOptionMap.get(rbKey))}
                                                   data-msg-required={errorKey != "" ? errorKey : "error.control.common"}
                                                   data-rule-required={required}/>
                                            <label className="RadioInput-label" htmlFor={dynamicId + "-" + i}>
                                                <FormatMessage id={rbKey}/>
                                            </label>
                                            {requireExplain.toString() == (i + 1).toString() &&
                                                <a className="LearnMoreLink" onClick={() => this.handleShowModal()}>
                                                    <FormatMessage id="control.explain"/>
                                                </a>
                                            }
                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>
                        <p className="AnswerField-errorMessage"></p>
                    </div>
                    {requireOptional != "" && <div className="AnswerField-optionLabel">
                        <FormatMessage id="control.requireOptional"/>
                    </div>}
                </div>
                {this.state.showModal &&
                    <LearnMore_LightBox contentKey={"explainthis." + pageid}
                                        handleOpenModal={() => this.handleShowModal()}/>
                }
            </div>
        );
    }

    handleShowModal() {
        this.setState({
            showModal: !this.state.showModal
        })
    }

    handleRadioChange(property, value) {
        this.setState({
            radioVal: value
        })
        const applicationData = this.state.application.applicationData;
        applicationData[property] = value
        dot.object(applicationData);
        this.props.dispatchApplicationData(applicationData)
    }
}

export default RadioOptionWithValue;
